import Vue from 'vue'

import VueGeolocation from '../infrastructure/services/geoPosition.js'
Vue.use(VueGeolocation)
